export const HOMEPAGE_URL = 'https://fiduciaps.com/';
export const BASENAME = {
    'localhost:3000': '/',
    'fiduciaps.com': '/business-assessment/',
}